module.exports = __webpack_public_path__ + "img/35676-089.06b269bf.jpg";